/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ClassSessionDto,
    ClassSessionDtoFromJSON,
    ClassSessionDtoFromJSONTyped,
    ClassSessionDtoToJSON,
} from './ClassSessionDto';
import {
    StudentDto,
    StudentDtoFromJSON,
    StudentDtoFromJSONTyped,
    StudentDtoToJSON,
} from './StudentDto';
import {
    TrusteeDto,
    TrusteeDtoFromJSON,
    TrusteeDtoFromJSONTyped,
    TrusteeDtoToJSON,
} from './TrusteeDto';

/**
 * 
 * @export
 * @interface AttendanceDto
 */
export interface AttendanceDto {
    /**
     * 
     * @type {string}
     * @memberof AttendanceDto
     */
    id?: string | null;
    /**
     * 
     * @type {TrusteeDto}
     * @memberof AttendanceDto
     */
    trustee?: TrusteeDto;
    /**
     * 
     * @type {StudentDto}
     * @memberof AttendanceDto
     */
    student?: StudentDto;
    /**
     * 
     * @type {ClassSessionDto}
     * @memberof AttendanceDto
     */
    classSession?: ClassSessionDto;
    /**
     * 
     * @type {Date}
     * @memberof AttendanceDto
     */
    timestamp?: Date | null;
}

export function AttendanceDtoFromJSON(json: any): AttendanceDto {
    return AttendanceDtoFromJSONTyped(json, false);
}

export function AttendanceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'trustee': !exists(json, 'trustee') ? undefined : TrusteeDtoFromJSON(json['trustee']),
        'student': !exists(json, 'student') ? undefined : StudentDtoFromJSON(json['student']),
        'classSession': !exists(json, 'classSession') ? undefined : ClassSessionDtoFromJSON(json['classSession']),
        'timestamp': !exists(json, 'timestamp') ? undefined : (json['timestamp'] === null ? null : new Date(json['timestamp'])),
    };
}

export function AttendanceDtoToJSON(value?: AttendanceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'trustee': TrusteeDtoToJSON(value.trustee),
        'student': StudentDtoToJSON(value.student),
        'classSession': ClassSessionDtoToJSON(value.classSession),
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp === null ? null : value.timestamp.toISOString()),
    };
}

